import React from "react";
import { LayoutContext } from "../context/LayoutContext";
export const useLayout = () => {
    return React.useContext(LayoutContext);
  };
